import Vue from 'vue'

import uiToolbarItemChangeIco from './src/ui-toolbar-item-change-ico.vue';
import uiToolbarItem from './src/ui-toolbar-item.vue';
import uiToolbarSeparator from './src/ui-toolbar-separator.vue';
import uiToolbar from './src/ui-toolbar.vue';

var components = [
  uiToolbarItemChangeIco,
  uiToolbarItem,
  uiToolbarSeparator,
  uiToolbar
]

components.forEach(function(component) {
  Vue.component(component.extendOptions.name, component);
})

export default components;



//////////////////
// WEBPACK FOOTER
// ./~/ui-toolbar/index.js
// module id = 566
// module chunks = 0